module.exports = __webpack_public_path__ + "img/filter_active.88df1eba.svg";